import React, { Component } from "react";
import PropTypes from "prop-types";
import Transition from "react-transition-group/Transition";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import $ from "jquery";
import {
  Link,
  scrollSpy,
  scroller,
  animateScroll as scroll,
  Events,
} from "react-scroll";

import { multiLanguage } from "../hoc";
import { assetsPath } from "../utils";
import { getHeaderHeight } from "../utils/navigation";

import ArrowDown from "./icons/ArrowDown";
import ArrowUp from "./icons/ArrowUp";
import BackgroundImage from "./BackgroundImage";
import List from "./List";
import ListItem from "./ListItem";
import HamburgerIcon from "./HamburgerIcon";

const durationEnter = 200;
const durationExit = 1000;

const defaultStyle = {
  transition: `opacity ${durationEnter}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { transition: `opacity ${durationExit}ms ease-in-out` },
};

class Header extends Component {
  static propTypes = {
    mainLogo: PropTypes.string.isRequired,
    subLogo: PropTypes.string.isRequired,
    hasSubHeader: PropTypes.bool,
    language: PropTypes.string.isRequired,
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
      })
    ),
  };
  static defaultProps = {
    mainLogo: "http://lagunaproperty.com/images/flogo_01_h.svg",
    subLogo: "http://lagunaproperty.com/images/laguna-parkside-residences.png",
    hasSubHeader: true,
    languages: [
      {
        name: "ENGLISH",
        key: "en",
      },
      {
        name: "中文",
        key: "cn",
      },
      {
        name: "РУССКИЙ",
        key: "ru",
      },
    ],
    mainMenus: [
      {
        key: "location",
        label: "Location",
        items: [],
      },
      { key: "sanctuary-club", label: "The Santuary Club" },
      { key: "resales", label: "Resales" },
      { key: "rental", label: "Rentals" },
      { key: "news", label: "News/Promotions" },
      { key: "about-us", label: "About us" },
      { key: "contact", label: "Contact" },
    ],
    projectSections: [
      { key: "gallery", label: "Gallery" },
      { key: "concept", label: "Concept" },
      { key: "masterplan", label: "Master Plan" },
      { key: "siteplan", label: "Site Plan" },
      { key: "residences", label: "Residences" },
      { key: "destination", label: "Destination" },
      { key: "sanctuary-club", label: "The Santuary Club" },
      { key: "faq", label: "FAQ" },
      { key: "e-brochure", label: "E-Brochure" },
    ],
  };
  state = {
    subHeaderScrollLeft: 0,
    showSubHeaderRightArrow: true,
    scrollValue: 200,
    offset: 86,
    isLg: false,
    isSm: false,
    small: false,
    showMenu: false,
  };

  leftMenus = [
    {
      label: "The Santuary Club",
      key: "sanctuary-club",
    },
    {
      label: "Resales",
      key: "resale",
    },
    {
      label: "Rentals",
      key: "rental",
    },
  ];

  rightMenus = [
    {
      label: "News/Promotions",
      key: "news",
    },
    {
      label: "About us",
      key: "about-us",
    },
    {
      label: "Contact",
      key: "contact-us",
    },
  ];

  lastScrollY = 0;
  animating = false;

  // ======================================================
  // Commit Phase
  // Can work with DOM, run side effects, schedule updates.
  // ======================================================
  componentDidMount = () => {
    this.sections = document.querySelectorAll(".main-content section");
    this.firstSection = this.sections[0];
    this.lastSection = this.sections[this.sections.length - 1];
    this.btnUp = document.querySelector(".button-scroll-to-section.up");
    this.btnDown = document.querySelector(".button-scroll-to-section.down");

    window.addEventListener("scroll", this.handleScrollPage);
    window.addEventListener("resize", this.updateDimensions);
    // window.addEventListener("hashchange", this.closeDrawer);
    // window.addEventListener("wheel", this.handleMouseWheel);

    scrollSpy.update();
    this.updateDimensions();

    // Check hash, if there is hash then scroll to that section
    if (window.location.hash === "") {
      $("html, body")
        .stop()
        .animate({ scrollTop: 1 }, 10)
        .animate({ scrollTop: 0 }, 10); // trigger scroll to hilight 'gallery'
    }
  };
  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (prevState.subHeaderScrollLeft !== this.state.subHeaderScrollLeft) {
      // document.getElementById('sub-header').scrollLeft = this.state.subHeaderScrollLeft;
      $(".sub-header")
        .stop()
        .animate({ scrollLeft: this.state.subHeaderScrollLeft }, 300);
    }

    if (
      _.get(prevState, "location.hash") !== _.get(this.state, "location.hash")
    ) {
      const hash = this.state.location.hash.substr(1);
      this.scrollToSection(hash);
    }
  };
  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScrollPage);
    window.removeEventListener("resize", this.updateDimensions);
  };

  // ======================================================
  // Pre-commit Phase
  // Can read the DOM
  // ======================================================
  getSnapshotBeforeUpdate = (prevProps, prevState) => {
    return {};
  };
  // ======================================================
  // Render Phase
  // Pure and no side effects. May be paused, aborted or restarted by React.
  // ======================================================
  static getDerivedStateFromProps(props, state) {
    // console.log('Header getDerivedStateFromProps', props.location, state.location, !_.isEqual(props.location, state.location));
    if (!_.isEqual(props.location, state.location)) {
      return {
        showMenu: false,
        location: props.location,
      };
    }
    return null;
  }
  // ======================================================
  // Private Methods
  // ======================================================
  updateDimensions = () => {
    const width = window.innerWidth;
    let offset = -90;
    if (width > 768) offset = -152;
    if (width > 1200) offset = -86;
    if (this.state.offset !== offset) this.setState({ offset });
  };
  getBaseHref = (key = "base") => {
    const { language } = this.props;
    const map = {
      base: `${process.env.REACT_APP_LAGUNA_PROPERTY_URL}/${language}`,
      bintan: `${process.env.REACT_APP_LAGUNA_PROPERTY_BINTAN_URL}`,
      phuketDusitDeluxePoolVilla: `/${language}/projects/phuket/dusit-laguna-resort-villas-phuket`,
      phuketLagunaPark: `/${language}/project/phuket/laguna-park`,
      phuketVillageResidences: `/${language}/projects/phuket/laguna-village-residences`,
      phuketLagunaPark2: `/${language}/projects/phuket/laguna-park-2`,
      langco: `${process.env.REACT_APP_LAGUNA_PROPERTY_LANGCO_URL}/${language}`,
      skypark: `/${language}/projects/phuket/skypark`,
      lagunaBeachSide: `/${language}/projects/phuket/laguna-beachside`,
      lagunaLakesideResidences: `/${language}/projects/phuket/laguna-lakeside-residences`,
      lagunaSeasideResidences: `/${language}/projects/phuket/laguna-seaside-residences`,
    };
    return map[key];
  };

  // handleMouseWheel = event => {
  //   console.info(event.wheelDelta);
  //   if (event.wheelData < 0) {
  //     this.handleScrollDown();
  //   } else {
  //     this.handleScrollUp();
  //   }
  // }

  // Page Scroll (เอาไว้ทำให้ Header หดลง)
  handleScrollPage = () => {
    // this.lastScrollY = window.scrollY;
    const pageYOffset =
      window.pageYOffset || document.documentElement.scrollTop;
    this.lastScrollY = pageYOffset;
    let small = false;
    if (this.lastScrollY > 30) {
      small = true;
    }
    this.setState({
      small,
    });

    const sectionIndex = this.getSectionIndex();
    // console.log('getSectionIndex', sectionIndex);
    // const isFirstSection = sectionIndex === 0;
    // const isLastSection = sectionIndex + 1 === this.props.projectSections.length;

    if (sectionIndex !== -1) {
      // Show / Hide Button Up & Down
      if (pageYOffset > 0.5 * this.firstSection.offsetHeight) {
        // if (!isFirstSection) {
        // console.log('show top bottom');
        this.btnUp.classList.remove("hide");
      } else {
        // console.log('hide top bottom');
        this.btnUp.classList.add("hide");
      }
      // console.log('pageYOffset', pageYOffset);
      // console.log('window.innerHeight', window.innerHeight);
      // console.log('document.body.scrollHeight', document.body.scrollHeight);
      // console.log('pageYOffset + window.innerHeight - document.body.scrollHeight', pageYOffset + window.innerHeight - document.body.scrollHeight);
      if (
        document.body.scrollHeight - (pageYOffset + window.innerHeight) >=
        40
      ) {
        // if (!isLastSection) {
        // console.log('show down bottom');
        this.btnDown.classList.remove("hide");
      } else {
        // console.log('hide down bottom');
        this.btnDown.classList.add("hide");
      }
    }
  };

  setSubheaderScrollHorizontalPosition = (scrollLeft) => {
    const subheader = document.getElementById("sub-header");
    const { scrollWidth, offsetWidth } = subheader;
    const showSubHeaderRightArrow =
      scrollWidth - (scrollLeft + offsetWidth) > this.state.scrollValue;

    this.setState({
      subHeaderScrollLeft: scrollLeft,
      showSubHeaderRightArrow,
    });
  };

  handleClickSubMenuRightArrow = () => {
    // Get current Scroll;
    const subheader = document.getElementById("sub-header");
    const scrollLeft = subheader.scrollLeft;
    this.setSubheaderScrollHorizontalPosition(
      scrollLeft + this.state.scrollValue
    );
  };

  handleSetActive = (to) => {
    const navElem = document.getElementById(`nav-${to}`);
    if (navElem) {
      const navElemLeft = navElem.offsetLeft;
      const navElemWidth = navElem.offsetWidth;
      const windowWidth = window.innerWidth;
      const posLeft = -(0.5 * windowWidth) + navElemLeft + 0.5 * navElemWidth;
      this.setSubheaderScrollHorizontalPosition(posLeft);
    }
  };

  handleSubHeaderScroll = (e) => {
    const subheader = document.getElementById("sub-header");
    const { scrollLeft, scrollWidth, offsetWidth } = subheader;
    const showSubHeaderRightArrow =
      scrollWidth - (scrollLeft + offsetWidth) > this.state.scrollValue;
    this.setState({ showSubHeaderRightArrow });
  };

  handleSwitchLanguage = (e) => {
    const { language, location } = this.props;
    const { pathname } = location;
    const nextLanguage = e.target.lang;
    // console.log(pathname, language, nextLanguage)
    const nextUrl = _.replace(pathname, `/${language}/`, `/${nextLanguage}/`);
    this.props.history.push(nextUrl);
  };

  toggleShowMenu = (target) => {
    const showMenu = _.isBoolean(target) ? target : !this.state.showMenu;
    // console.log('showMenu', showMenu);
    const overflow = showMenu ? "hidden" : "auto";
    document.body.style.overflow = overflow;

    this.setState({ showMenu });
  };

  /*
   * Button Scroll Up / Down
   */

  // handleScroll = (direction) => {
  // const sections = document.querySelectorAll('.main-content section');
  // let headerHeight = getHeaderHeight();

  /*
    const pageYOffset =  window.pageYOffset || document.documentElement.scrollTop;
    _.forEach(sections, (section, sectionIndex) => {
      const stickyTop = section.offsetTop;
      const stickyBottom = stickyTop + section.offsetHeight;
      // console.log('pageYOffset', pageYOffset);
      // console.log('headerHeight', headerHeight);
      // console.log('stickyTop', stickyTop);
      // console.log('stickyBottom', stickyBottom);
      // console.log('pageYOffset + headerHeight >= stickyTop', pageYOffset + headerHeight >= stickyTop);
      // console.log('pageYOffset + headerHeight <= stickyBottom', pageYOffset + headerHeight <= stickyBottom);
      if (pageYOffset + headerHeight >= stickyTop && pageYOffset + headerHeight < stickyBottom) {
        const nextIndex = (direction === 'up') ? sectionIndex - 1 : sectionIndex + 1;
        // console.log('sectionIndex', sectionIndex);
        // console.log('nextIndex', nextIndex);
        const nextSection = sections[nextIndex];
        // console.log('nextSection', nextSection);
        if (nextSection) {
          const scrollTargetValue = (direction === 'up') ? nextSection.offsetTop - headerHeight : nextSection.offsetTop - headerHeight;
          // console.log('scrollTargetValue', scrollTargetValue);
          $('html, body').stop().animate({ scrollTop: scrollTargetValue }, 800); // eslint-disable-line
          return false
        }
        return false
      }
    });
    */
  // }

  scrollToSection = (sectionId) => {
    // if (this.animating === false) {
    const { offset } = this.state;

    // this.animating = true;
    // const _self = this;

    // Events.scrollEvent.register('end', function(to, element) {
    //   _self.animating = false;
    //   Events.scrollEvent.remove('end');
    // });

    scroller.scrollTo(sectionId, {
      duration: 1000,
      delay: 100,
      smooth: true,
      offset: offset, // Scrolls to element + 50 pixels down the page
    });
    // }
  };

  getSectionIndex = () => {
    const hash = window.location.hash.substr(1);
    const sections = this.props.projectSections;
    const sectionIndex = _.findIndex(
      sections,
      (section) => section.key === hash
    );
    return sectionIndex;
  };

  getCurrentSection = () => {
    const hash = window.location.hash.substr(1);
    const sections = this.props.projectSections;
    const sectionIndex = _.findIndex(
      sections,
      (section) => section.key === hash
    );
    const section = sections[sectionIndex];
    return document.getElementById(section.key);
  };

  atTopOfSection = () => {
    const section = this.getCurrentSection();

    const pageYOffset =
      window.pageYOffset || document.documentElement.scrollTop; // pageScroll
    const headerHeight = getHeaderHeight();
    // const sectionHeight = section.offsetHeight;
    const sectionTop = section.offsetTop;
    // const windowHeight = window.innerHeight;
    // console.log('pageYOffset', pageYOffset);
    // console.log('sectionHeight', sectionHeight);
    // console.log('sectionTop', sectionTop);
    // console.log('windowHeight', windowHeight);
    // console.log('pageYOffset + headerHeight, sectionTop', pageYOffset + headerHeight, sectionTop, pageYOffset + headerHeight === sectionTop)
    return pageYOffset + headerHeight - sectionTop < 10;
  };

  atBottomOfSection = () => {
    const section = this.getCurrentSection();

    const pageYOffset =
      window.pageYOffset || document.documentElement.scrollTop; // pageScroll
    const sectionHeight = section.offsetHeight;
    const sectionTop = section.offsetTop;
    const windowHeight = window.innerHeight;
    // console.log('pageYOffset', pageYOffset);
    // console.log('sectionHeight', sectionHeight);
    // console.log('sectionTop', sectionTop);
    // console.log('windowHeight', windowHeight);
    // console.log('pageYOffset + windowHeight, sectionTop + sectionHeight', pageYOffset + windowHeight, sectionTop + sectionHeight, (pageYOffset + windowHeight) - (sectionTop + sectionHeight) < 10);
    return sectionTop + sectionHeight - (pageYOffset + windowHeight) < 10;
  };

  handleScrollUp = () => {
    const hash = window.location.hash.substr(1);
    const sections = this.props.projectSections;
    const sectionIndex = _.findIndex(
      sections,
      (section) => section.key === hash
    );
    // console.log('sectionIndex', sectionIndex);
    const prevSection = sections[sectionIndex - 1];
    if (prevSection) this.scrollToSection(prevSection.key);
  };

  handleScrollDown = () => {
    const hash = window.location.hash.substr(1);
    const sections = this.props.projectSections;
    const sectionIndex = _.findIndex(
      sections,
      (section) => section.key === hash
    );
    const nextIndex = hash ? sectionIndex + 1 : 1;
    const nextSection = sections[nextIndex];
    if (nextSection) {
      this.scrollToSection(nextSection.key);
      return;
    }
    // no next Section, try to scroll to bottom
    scroll.scrollToBottom();
  };
  // End of Button Scroll Up / Down

  handleClickSubMenuItem = (subMenu) => {
    console.log("handleClickSubMenuItem", subMenu);
    const { history, location } = this.props;
    history.push(
      `${location.pathname}?currentSection=${subMenu.currentSection}`
    );
  };

  renderSubHeader = () => {
    const { offset, showSubHeaderRightArrow } = this.state;
    const { subLogo, projectSections, t } = this.props;
    // console.log("renderSubHeader", projectSections);
    return (
      <div
        className="sub-header"
        id="sub-header"
        onScroll={this.handleSubHeaderScroll}
      >
        <div>
          <a className="item logo">
            <img className="sub-logo" src={subLogo} alt="Logo" />
          </a>
          {projectSections.map((subMenu, key) => {
            return (
              <div
                className={`item item-${subMenu.key} ${
                  subMenu.hideOnMobile ? "d-none d-md-flex" : ""
                } `}
                id={`nav-${subMenu.key}`}
                key={`item-${subMenu.key}`}
              >
                <Link
                  id={`nav-${subMenu.key}`}
                  key={`nav-${subMenu.key}`}
                  activeClass="is-current"
                  className="item sub"
                  to={subMenu.key}
                  spy={true}
                  hashSpy={true}
                  // containerId={subMenu.key}
                  smooth={true}
                  duration={500}
                  isDynamic={true}
                  ignoreCancelEvents={true}
                  offset={offset}
                  onSetActive={this.handleSetActive}
                >
                  {t(subMenu.label)}
                </Link>
                {_.size(subMenu.subitem) > 0 && (
                  <div className="item container" id={`nav-sub-${subMenu.key}`}>
                    {_.map(subMenu.subitem, (eachItem, key) => (
                      <Link
                        id={`nav-${subMenu.key}`}
                        key={`nav-sub-${key}`}
                        activeClass="is-current"
                        className="item subitem"
                        to={subMenu.key}
                        spy={true}
                        hashSpy={true}
                        // containerId={subMenu.key}
                        smooth={true}
                        duration={500}
                        isDynamic={true}
                        ignoreCancelEvents={true}
                        offset={offset}
                        onSetActive={this.handleSetActive}
                        onClick={() => this.handleClickSubMenuItem(eachItem)}
                      >
                        {t(eachItem.label)}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <BackgroundImage
          onClick={this.handleClickSubMenuRightArrow}
          className="scroll"
          style={{ opacity: showSubHeaderRightArrow ? 1 : 0 }}
          image={`${assetsPath()}/images/icon/rightscroll.svg`}
          position="right center"
          repeat="no-repeat"
          size="auto 80%"
        />
      </div>
    );
  };

  closeDrawer = () => this.toggleShowMenu(false);

  goto = (to) => {
    this.closeDrawer();
    this.props.history.push(to);
  };
  renderProjectDrawerMenu = (key, label, baseUrl) => {
    // const residenseItems = key === 'laguna-park-2' ? [
    //   <ListItem text={this.renderContent({
    //     en: 'TOWNHOME',
    //     ru: 'Таунхаусы',
    //     cn: '联排别墅',
    //   })} className="list-item-project-subpage" to={`${baseUrl}/#townhome`} />,
    //   <ListItem text={this.renderContent({
    //     en: 'VILLA',
    //     ru: 'Виллы',
    //     cn: '独栋别墅',
    //   })} className="list-item-project-subpage" to={`${baseUrl}/#villa`} />,
    // ] : [];
    return (
      <ListItem
        text={label}
        className="list-item-project"
        key={baseUrl}
        to={baseUrl}
        items={
          key !== "skypark" && [
            <ListItem
              key="gallery"
              text="Gallery"
              className="list-item-project-page"
              to={`${baseUrl}/#gallery`}
              showChildren
              showToggleIcon={false}
              items={[
                <ListItem
                  key="images"
                  text="Images"
                  className="list-item-project-subpage"
                  onClick={() => this.goto(`${baseUrl}/#images`)}
                />,
                <ListItem
                  key="video"
                  text="Video"
                  className="list-item-project-subpage"
                  onClick={() => this.goto(`${baseUrl}/#video`)}
                />,
              ]}
            />,
            <ListItem
              key="concept"
              text="Concept"
              className="list-item-project-page"
              onClick={() => this.goto(`${baseUrl}/#concept`)}
            />,
            <ListItem
              key="masterplan"
              text="Master plan"
              className="list-item-project-page"
              onClick={() => this.goto(`${baseUrl}/#masterplan`)}
            />,
            <ListItem
              key="siteplan"
              text="Site plan"
              className="list-item-project-page"
              onClick={() => this.goto(`${baseUrl}/#siteplan`)}
            />,
            <ListItem
              key="residences"
              text="Residences"
              className="list-item-project-page"
              onClick={() => this.goto(`${baseUrl}/#residences`)}
              showChildren
              // items={residenseItems}
            />,
            <ListItem
              key="residences"
              text="Destination"
              className="list-item-project-page"
              onClick={() => this.goto(`${baseUrl}/#destination`)}
            />,
            <ListItem
              key="the-sanctuary-club"
              text="The Santuary Club"
              className="list-item-project-page"
              onClick={() => this.goto(`${baseUrl}/#sanctuary-club`)}
            />,
          ]
        }
      />
    );
  };

  renderDrawerMenu = () => {
    const { showMenu } = this.state;
    const { language } = this.props;
    return (
      <Transition
        in={showMenu}
        timeout={{ enter: durationEnter, exit: durationExit }}
        mountOnEnter
        unmountOnExit
      >
        {(state) => (
          <div
            className={`navigation active ${showMenu ? "active" : ""}`}
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            <List
              transitionDuration={2000}
              transitionInDelay={200}
              animState={state}
            >
              <ListItem
                text="Locations"
                showChildren
                items={[
                  <ListItem
                    key="bintan"
                    renderText={() => (
                      <span>
                        <strong>Bintan</strong>
                        <span className="secondary">Laguna Park</span>
                      </span>
                    )}
                    className="list-item-location"
                    to="http://bintan.lagunaproperty.com"
                  />,
                  <ListItem
                    key="phuket"
                    text="Phuket"
                    className="list-item-location"
                    items={[
                      this.renderProjectDrawerMenu(
                        "laguna-beachside",
                        "Laguna Beachside Residences",
                        this.getBaseHref("lagunaBeachSide")
                      ),
                      this.renderProjectDrawerMenu(
                        "laguna-lakeside-residences",
                        "Laguna Lakeside Residences",
                        this.getBaseHref("lagunaLakesideResidences")
                      ),
                      this.renderProjectDrawerMenu(
                        "laguna-seaside-residences",
                        "Laguna Seaside Residences",
                        this.getBaseHref("lagunaSeasideResidences")
                      ),
                      this.renderProjectDrawerMenu(
                        "laguna-park",
                        "Laguna Parkside Residences",
                        this.getBaseHref("phuketLagunaPark")
                      ),
                      this.renderProjectDrawerMenu(
                        "laguna-park-2",
                        "Laguna Park 2",
                        this.getBaseHref("phuketLagunaPark2")
                      ),
                      this.renderProjectDrawerMenu(
                        "laguna-village-residences",
                        "Laguna Village Residences",
                        this.getBaseHref("phuketVillageResidences")
                      ),
                      this.renderProjectDrawerMenu(
                        "skypark",
                        "Skypark",
                        this.getBaseHref("skypark")
                      ),
                    ]}
                  />,
                  <ListItem
                    key="langco"
                    text="LĂNG CÔ"
                    renderText={() => (
                      <span>
                        <strong>LĂNG CÔ</strong>
                        <span className="secondary">Laguna Park</span>
                      </span>
                    )}
                    to="http://www.lagunalangco.com/en/"
                    className="list-item-location"
                  />,
                ]}
              />
              <ListItem
                text="The Santuary Club"
                to={`/${language}/sanctuary-club`}
              />
              <ListItem text="Resales" to={`/${language}/resales`} />
              <ListItem text="Rentals" to={`/${language}/rental`} />
              <ListItem text="News/Promotions" to={`/${language}/news`} />
              <ListItem text="About us" to={`/${language}/about-us`} />
              <ListItem text="Contact" to={`/${language}/contact`} />
            </List>
          </div>
        )}
      </Transition>
    );
  };
  getLanguageIcon = (language) => {
    const { languages, currentLanguage } = this.props;
    const targetLanguage = _.find(languages, (language) => {
      return language.key === currentLanguage;
    });
    return (targetLanguage && targetLanguage.icon) || "";
  };
  renderLanguageOption = ({ name, key, icon, ...rest }) => {
    return (
      <li key={key}>
        <a lang={key} onClick={this.handleSwitchLanguage}>
          <img alt="" src={icon} />
          {name}
        </a>
      </li>
    );
  };
  renderMenu = ({ label, key }) => {
    return (
      <a key={key} href={`${this.getBaseHref()}/${key}`} className="item">
        {this.renderContent(label)}
      </a>
    );
  };

  renderContent = (key) => {
    const { t } = this.props;
    return t(key);
  };
  render() {
    const { mainLogo, hasSubHeader, languages, language } = this.props;
    return (
      <React.Fragment>
        <header className={`${this.state.small ? "small" : ""}`}>
          <div className="main-header">
            <div className="left">
              <div className="item location">
                <span className="title">{this.renderContent("Locations")}</span>
                <div className="hover-container">
                  <ul className="list">
                    {/* <li className="item">
                      <strong>{this.renderContent("Bintan")}</strong>
                      <a
                        target="_blank"
                        href={this.getBaseHref("bintan")}
                        rel="noopener noreferrer"
                      >
                        {this.renderContent("Laguna Park")}
                      </a>
                    </li> */}
                    <li className="item">
                      <strong>{this.renderContent("Phuket")}</strong>
                      <ul className="location-sub-list">
                        <li className="item">
                          <a
                            href={this.getBaseHref("lagunaBeachSide")}
                            rel="noopener noreferrer"
                          >
                            {this.renderContent("Laguna Beachside")}
                          </a>
                        </li>
                        <li className="item">
                          <a
                            href={this.getBaseHref("lagunaLakesideResidences")}
                            rel="noopener noreferrer"
                          >
                            {this.renderContent("Laguna Lakeside Residences")}
                          </a>
                        </li>
                        <li className="item">
                          <a
                            href={this.getBaseHref("lagunaSeasideResidences")}
                            rel="noopener noreferrer"
                          >
                            {this.renderContent("Laguna Seaside Residences")}
                          </a>
                        </li>
                        <li className="item">
                          <a
                            href={this.getBaseHref("phuketLagunaPark")}
                            rel="noopener noreferrer"
                          >
                            {this.renderContent("Laguna Park")}
                          </a>
                        </li>
                        <li className="item">
                          <a
                            href={this.getBaseHref("phuketLagunaPark2")}
                            rel="noopener noreferrer"
                          >
                            {this.renderContent("Laguna Park 2")}
                          </a>
                        </li>
                        <li className="item">
                          <a
                            href={this.getBaseHref("phuketVillageResidences")}
                            rel="noopener noreferrer"
                          >
                            {this.renderContent("Laguna Village Residences")}
                          </a>
                        </li>
                        <li className="item">
                          <a
                            href={this.getBaseHref("skypark")}
                            rel="noopener noreferrer"
                          >
                            {this.renderContent("Skypark")}
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="item">
                      <strong>{this.renderContent("Lăng Cô")}</strong>
                      <a
                        target="_blank"
                        href={this.getBaseHref("langco")}
                        rel="noopener noreferrer"
                      >
                        {this.renderContent("Laguna Park")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {this.leftMenus.map(this.renderMenu)}
            </div>
            <a href={this.getBaseHref()} className="item logo">
              <img className="main-logo" src={mainLogo} alt="" />
            </a>
            <div className="right">{this.rightMenus.map(this.renderMenu)}</div>
          </div>
          {hasSubHeader && this.renderSubHeader()}
          <button onClick={this.toggleShowMenu} className="menu-button">
            <HamburgerIcon width={42} height={42} open={this.state.showMenu} />
            <span>{this.renderContent("Menu")}</span>
          </button>
          {this.renderDrawerMenu()}
          <a href={`${this.getBaseHref()}/contact-us`} className="mail-box">
            <img src={`${assetsPath()}/images/icon/email.svg`} alt="" />
          </a>
          <div className="language">
            <img
              className="current-lang"
              alt=""
              src={this.getLanguageIcon(language)}
            />
            <ul className="list">{languages.map(this.renderLanguageOption)}</ul>
          </div>
        </header>
        {hasSubHeader && (
          <React.Fragment>
            <div className="button-scroll-wrapper up">
              <button
                onClick={this.handleScrollUp}
                className="button-scroll-to-section up"
              >
                <ArrowUp width={40} height={40} fill="#04a8a6" />
              </button>
            </div>
            <div className="button-scroll-wrapper down">
              <button
                onClick={this.handleScrollDown}
                className="button-scroll-to-section down"
              >
                <ArrowDown width={40} height={40} fill="#04a8a6" />
              </button>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default multiLanguage()(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js